import { appColors } from '../../../globalStyles'
import { tickCallbackClosure } from './ticks'
import { renderLegend } from './legend'
import { customTooltip } from './tooltip'

export const buildChartJsOptionsProp = (props) => {
  const { colors, datasets, stacked } = props

  const actualData = datasets ? datasets.find(dataset => dataset.label == "Actual") : undefined
  const minValue = actualData ? Math.min(...actualData.data.map(point => point.y)) : 0

  const scales = scalesOptions(colors, minValue, stacked)
  const plugins = pluginsOptions()
  const layout = layoutOptions()
  const hover = hoverOptions()
  const elements = elementsOptions()

  return {
    plugins,
    scales,
    layout,
    hover,
    elements
  }
}

const scalesOptions = (colors, minValue, stacked) => ({
  x: {
    grid: {
      display: true,
      drawTicks: true,
      drawBorder: true,
      drawOnChartArea: true,
      lineWidth: 1,
      color: appColors.card_line_color
    },
    ticks: {
      display: true,
      beginAtZero: false,
      stepSize: 1,
      callback: tickCallbackClosure(),
      autoSkip: false,
      maxRotation: 0,
      minRotation: 0,
      font: {
        size: 16
      },

      color: colors.primaryColor
    }
  },
  y: {
    stacked,
    suggestedMin: minValue * 0.9,
    grid: {
      display: true,
      drawTicks: false,
      drawBorder: true,
      drawOnChartArea: false
    },
    ticks: {
      display: false,
      beginAtZero: false,
      callback: () => {}
    }
  }
})

const pluginsOptions = () => ({
  legend: {
    display: false
  },
  tooltip: tooltipsOptions(),
  legendComponent: {
    containerId: 'chart-legend',
    onUpdate: renderLegend,
  },
  crosshair: {
    width: 1
  },
  fillCb: {
    enabled: true
  }
})

const tooltipsOptions = () => ({
  enabled: false,
  mode: 'point',
  intersect: false,
  displayColors: false,

  external: customTooltip
})

const layoutOptions = () => {
  return {
  }
}

const hoverOptions = () => ({
  mode: 'interpolate',
  intersect: false,
})

const elementsOptions = () => ({
  point: {
    backgroundColor: appColors.system,
    borderColor: appColors.white,
    borderWidth: 2,
    hoverBorderWidth: 2
  }
})
